import { createAction, createReducer } from '@reduxjs/toolkit';
import { types } from '../types';

const translationCache = createAction(types.GET_TRANSLATION_CACHE_SUCCESS);

const initialState = {
  translationCache: {}
};

const TranslationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(translationCache, (state, action) => {
      state.translationCache = action.response;
    })
    .addDefaultCase(() => { });
});

export default TranslationReducer;